<div class="flex justify-content-center align-items-center">

  <button 
    (click)="click.emit()" 
    [ngClass]="getStyleClass()"
    [disabled]="disabled">
    <div class="flex align-items-center">
      <span *ngIf="!!icon">
        <i [ngClass]="'rem-btn-icon mr-2 pi pi-'+icon"></i>
      </span>
      <span *ngIf="!!label">
        {{ label }}
      </span>
    </div>
    <ng-content *ngIf="!label"></ng-content>
    
  </button>
</div>
